export default __webpack_public_path__ + "static/time-management-clock-3b309fc1f1c51d68754b2afee9b3d7d4.jpg";